module.exports = __webpack_public_path__ + "static/media/03.5228f5ca.png";